/* repo/collection */
import { fetch as fetchApi, isString } from "./api";
import { Permission, PermissionCodec } from "../store/permission/types";
import { withDecoded } from "./";

function mapToModel(data: object): Permission {
  return withDecoded(PermissionCodec, data, decoded => ({
    ...decoded
  }));
}

export async function fetch(): Promise<Permission> {
  return fetchApi({
    nestedResourcePath: ["access/permission"],
    id: null,
    params: {}
  }).then(response =>
    mapToModel(
      isString(response.data) ? JSON.parse(response.data) : response.data
    )
  );
}
